module.exports = __webpack_public_path__ + "media/fonts/Roboto/Roboto-Regular-30b57652c88c5dbd65de73aba00331a9.eot";